const DEFAULT_API_BASE =
  process.env.REACT_APP_API_BASE_URL || 'https://api.manthuliorangics.in/api';
// process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

/** Origin where the backend serves /uploads (API host without /api suffix). */
export const getUploadsBaseUrl = () => {
  const explicit = process.env.REACT_APP_UPLOADS_BASE_URL?.trim();
  if (explicit) return explicit.replace(/\/+$/, '');

  return DEFAULT_API_BASE.replace(/\/api\/?$/, '').replace(/\/+$/, '');
};

/**
 * Build a full image URL from a backend path.
 * In production, relative /uploads/... paths must point at the API server, not the admin host.
 */
export const getImageUrl = (path, defaultSubfolder) => {
  if (!path) return '';

  const raw = String(path).trim();
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalized = raw.replace(/\\/g, '/');
  const lower = normalized.toLowerCase();
  const idx = lower.indexOf('uploads/');

  let relPath;
  if (idx >= 0) {
    relPath = normalized.slice(idx);
  } else if (defaultSubfolder) {
    relPath = `uploads/${defaultSubfolder}/${normalized.split('/').pop()}`;
  } else {
    relPath = normalized;
  }

  relPath = relPath.replace(/^\/+/, '');
  return `${getUploadsBaseUrl()}/${relPath}`;
};

export const getProductImageUrl = (imagePath) => {
  if (!imagePath) return undefined;
  return getImageUrl(imagePath, 'products');
};
